module.exports = __webpack_public_path__ + "img/face-cowboy-hat.f3e2bee6.svg";